export default __webpack_public_path__ + "static/media/box-ar.91706219.svg";